import { MenuDropdown } from '@/components/Common';
import { AlertModal } from '@/components/Layout/AlertModal/AlertModal';
import { ListItem } from '@/components/Ui';
import { useTipsList } from './TipsList.hook';

export const TipsList = () => {
  const {
    menuItems,
    isRemovingTip,
    isPublishModalOpen,
    setIsPublishModalOpen,
    handleConfirmPublish,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleConfirmDelete,
    tipToTogglePublish,
    isUpdatingTip,
    selectedTip,
    setTip,
    filteredTips = [],
  } = useTipsList();

  return (
    <div className="overflow-auto mb-6 pl-2">
      {filteredTips?.map((tip, index) => (
        <ListItem
          onClick={() => setTip(tip)}
          listItemStyle={`!bg-black !hover:border-l-[#FEC200] ${tip?._id === selectedTip?._id ? '!border-l-[#FEC200]' : ''}`}
          leftBorderColor={tip?.isPublished ? '#FFF' : '#616163'}
          focused={tip?.isPublished === true}
          key={index}
        >
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <h3 className="text-[15.478px] not-italic font-bold leading-[16.509px]">
                {tip?.title}
              </h3>
            </div>
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <MenuDropdown
                menuItems={menuItems(tip)}
                dotsStyle="bg-[#FEC20033]"
              />
            </div>
          </div>
        </ListItem>
      ))}

      <AlertModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Confirmation de suppression"
        message="Êtes-vous sûr de vouloir supprimer ce conseil ? Cette action est irréversible."
        buttonTitle={isRemovingTip ? 'Suppression en cours...' : 'Supprimer'}
        buttonCancelTitle="Annuler"
        handleConfirm={handleConfirmDelete}
      />

      <AlertModal
        isOpen={isPublishModalOpen}
        onClose={() => setIsPublishModalOpen(false)}
        title={
          tipToTogglePublish?.isPublished
            ? 'Confirmation de masquage'
            : 'Confirmation de publication'
        }
        message={
          tipToTogglePublish?.isPublished
            ? 'Êtes-vous sûr de vouloir masquer ce conseil ?'
            : 'Êtes-vous sûr de vouloir publier ce conseil ?'
        }
        buttonTitle={isUpdatingTip ? 'En cours...' : 'Confirmer'}
        buttonCancelTitle="Annuler"
        handleConfirm={handleConfirmPublish}
      />
    </div>
  );
};
